import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const HomePage = lazy(() => import('@/pages/home/ui/HomePage'))

export const Route = createFileRoute('/_protected/home')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense fallback={<Loader />}>
      <HomePage />
    </Suspense>
  )
}
